import { PostgrestClient } from "@supabase/postgrest-js";
import {
  API_PROGRAM_REST_TOKEN,
  API_PROGRAM_REST_URL,
} from "../helpers/payment-scope.helper";

const postgrest = new PostgrestClient(API_PROGRAM_REST_URL, {
  headers: {
    "x-api-token": API_PROGRAM_REST_TOKEN,
  },
});

export default postgrest;

